import classNames from 'classnames';
import React from 'react';
import styles from "./StepItem.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function StepItem({
  __active,
  __currentStep,
  onClick,
  onMouseEnter,
  onMouseLeave
}) {
  const classes = classNames(styles.stepItem, {
    [styles.active]: __active,
    [styles.hover]: onClick && !__currentStep
  });
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    onClick: onClick && !__currentStep ? onClick : undefined,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  });
}